// extracted by mini-css-extract-plugin
export var copyIcon = "_r7-2";
export var discountCard = "_r7-0";
export var discountCode = "_r7-3";
export var discountContent = "_r7-1";
export var loadingCard = "_r7-4";